import React from "react";
import ActionButton from "../Buttons/ActionButton";
import DefaultTools from "./DefaultTools";


type Props = {
  activeTool: string;
  onToolChange: (tool: string) => void;
};

const AnnotationToolbox = ({ activeTool, onToolChange }: Props) => {

  const handleToolChange = (tool) => {	
    onToolChange(tool);
  };

  return (
    <div className="annotation-sidebar">
      <div className="annotation-sidebar-content">
        {
          DefaultTools.map((tool, index) => {
            return (
              <ActionButton
                icon={tool.icon}
                label={tool.label}
                className={`annotation-sidebar-item ${tool.name == activeTool && "active"}`}
                onClick={() => handleToolChange(tool.name)}
                key={index}
              />
            )
          })
        }
      </div>
    </div>       
  );
};

export default AnnotationToolbox;
